<template>
  <div>
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
    <DebugListener />
    <app-spinner />
    <app-monitoring-tag />
  </div>
</template>

<!-- prettier-ignore -->
<script>

import AppSpinner from "./components/spinner/AppSpinner";
import DebugListener from "./components/debug/DebugListener";
import { addAccessibilityOnTab } from "./utils";
import { suscribeToastToMessages } from "../src/adapters/toastNotifierAdapter";

export default {
  components: {
    AppSpinner,
    DebugListener
  },
  mounted() {
    // Start listening Tab key to add Accessibility classes
    addAccessibilityOnTab();

    // Suscribes the toast notifier adapter to show a toast on every new message
    suscribeToastToMessages();
  }
};
</script>

<style lang="scss"></style>
